import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const MOBILE_BREAKPOINT = '1024px';

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
`;

const SidebarSection = styled.aside`
  width: 280px;
  flex-shrink: 0;
  background-color: #ffffff;
  border-right: 1px solid #e8e8e8;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: none;
  }
`;

const MainSection = styled.main`
  flex: 1;
  background-color: #fafafa;
  min-height: 100vh;
  overflow-x: hidden;
`;

const SearchLayout = ({ topBar, sidebar, children }) => (
  <LayoutContainer>
    {topBar}
    <ContentWrapper>
      <SidebarSection>{sidebar}</SidebarSection>
      <MainSection>{children}</MainSection>
    </ContentWrapper>
  </LayoutContainer>
);

SearchLayout.propTypes = {
  topBar: PropTypes.node,
  sidebar: PropTypes.node,
  children: PropTypes.node,
};

export default SearchLayout;

